import { ISelectComPesquisaProps, SelectComPesquisa } from "@/Components/SelectComPesquisa";
import { dadosBancarioToString } from "@/Models/Pessoa/DadosBancario";
import { useDadosBancarioListarPorPessoa } from "@/Services/Pessoa/DadosBancarioService";
import { Typography, Row, Flex, Col, Space, Select } from 'antd';
import { useEffect, useMemo } from "react";
import DadosBancarioDescriptonLine from "./DadosBancarioDescriptonLine";
import { EnumDadoBancarioTipo } from "@/Models/Pessoa/dadosBancario/DadosBancarioTipo";
import DadosBancarioPix from "@/Models/Pessoa/dadosBancario/DadosBancarioPix";
import { DadosBancarioConta } from "@/Models/Pessoa/dadosBancario/DadosBancarioConta";

interface IDadosBancarioPorPessoaSelect extends ISelectComPesquisaProps {
    filtros?:Parameters<typeof useDadosBancarioListarPorPessoa>[0]
}
export default function DadosBancarioPorPessoaSelect({
    loading,
    placeholder,
    allowClear,
    filtros,
    value,
    onChange,
    ...rest
}:IDadosBancarioPorPessoaSelect) {
    placeholder = placeholder ?? "Selecione";
    allowClear = allowClear ?? true;
    loading = loading ?? undefined;
    filtros = filtros ?? {
        codPessoa : 0
    }

    const {
        data,
        isLoading
    } = useDadosBancarioListarPorPessoa({
        ...filtros,
        enabled : filtros.codPessoa > 0 ? filtros.enabled : false
    });

    const valueItem = useMemo(() => {
        return data?.find(f => f.codigo === value) ?? null;
    }, [value, data]);

    const options = useMemo(() => data?.map(m => {
        return {
            value : m.codigo,
            label : dadosBancarioToString(m)
        }
    }), [data]);

    useEffect(() => {
        if ((value === undefined || (typeof value === "string" && value.trim() === '')) && options !== undefined && options.length === 1)
            onChange?.(options![0].value, options![0]);
    }, [options, value]);

    // useEffect(() => {
    //     // Testar em modo alteração
    //     onChange?.(undefined, {});
    // }, [filtros.codPessoa]);

    const pix:DadosBancarioPix = valueItem as DadosBancarioPix;
    const conta:DadosBancarioConta = valueItem as DadosBancarioConta;

    return <Row wrap={false}>
        <Col flex="auto">
            <SelectComPesquisa
                {...rest}
                placeholder={placeholder}
                allowClear={allowClear}
                loading={isLoading || loading}
                value={value}
                options={options}
                onChange={onChange}
            />
        </Col>
        <Col flex="20px" style={{ textAlign : "center" }}>
            {valueItem?.codTipo === undefined && <Typography.Text copyable={{ tooltips: false, text : ' ' }}></Typography.Text>}
            {valueItem?.codTipo === EnumDadoBancarioTipo.ChavePix && <Typography.Text copyable={{ tooltips: false, text : pix.chavePix }}></Typography.Text>}
            {valueItem?.codTipo === EnumDadoBancarioTipo.Conta && (valueItem as DadosBancarioConta) !== undefined  && <Typography.Text copyable={{ tooltips: false, text : dadosBancarioToString(conta) }}></Typography.Text>}
        </Col>
    </Row>;
}